<template>
  <div class="landing-tabs">
    <div class="tabs-nav">
      <div class="tab-extend extend-left"></div>
      <div
        @click="selected = 'available'"
        class="tab-nav-item"
        :class="selected === 'available' ? 'tab-selected' : ''"
      >
        Available deals
      </div>
      <div
        @click="selected = 'sector'"
        class="tab-nav-item"
        :class="selected === 'sector' ? 'tab-selected' : ''"
      >
        Sector investing support
      </div>
      <div
        @click="selected = 'support'"
        class="tab-nav-item"
        :class="selected === 'support' ? 'tab-selected' : ''"
      >
        Deal support community
      </div>
      <div
        @click="selected = 'contact'"
        class="tab-nav-item"
        :class="selected === 'contact' ? 'tab-selected' : ''"
      >
        Learn more
      </div>
      <div class="tab-extend extend-right"></div>
    </div>
    <div class="tabs-content container-xxl">
      <div v-if="selected === 'available'" class="tab-content-item">
        <available-tab />
      </div>
      <div v-if="selected === 'sector'" class="tab-content-item">
        <sectors-tab />
      </div>
      <div v-if="selected === 'support'" class="tab-content-item">
        <support-tab />
      </div>
      <div v-if="selected === 'contact'" class="tab-content-item">
        <contact-tab />
      </div>
    </div>
  </div>
</template>

<script>
import AvailableTab from "./available-tab.vue";
import SectorsTab from "./sectors-tab.vue";
import SupportTab from "./support-tab.vue";
import ContactTab from "./contact-tab.vue";

export default {
  name: "landing-tabs",
  components: {
    AvailableTab,
    SectorsTab,
    SupportTab,
    ContactTab,
  },
  data() {
    return {
      selected: "available",
    };
  },
};
</script>

<style scoped lang="scss">
.tabs-nav {
  display: flex;
}
.tab-nav-item {
  padding: 10px 25px;
  cursor: pointer;
  color: #fff;
  border-bottom: 1px solid #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: Poppins, Helvetica, "sans-serif" !important;
  @media (min-width: 768px) {
    font-size: 18px;
  }
  &.tab-selected {
    border: 1px solid #fff;
    border-bottom: none;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
}
.tabs-content {
  padding-top: 50px;
  padding-bottom: 80px;
}
.tab-content-item {
  padding-top: 20px;
  h5 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 30px;
  }
}
.tab-extend {
  flex: 1 1 auto;
  border-bottom: 1px solid #fff;
}
</style>
